/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail(value) {
    if (!('IsRequired' in value) || value['IsRequired'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'IsRequired': json['IsRequired'],
        'DefaultValue': json['DefaultValue'] == null ? undefined : json['DefaultValue'],
    };
}
export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'IsRequired': value['IsRequired'],
        'DefaultValue': value['DefaultValue'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail.js.map